export const FORM_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
};
